module.exports = function() {
  return new Worker(__webpack_public_path__ + "129c78a1d8dff7e33241.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./src/workers/pagesUpate.worker.js
// module id = 1282
// module chunks = 1